import css from 'styled-jsx/css'
import WebDeskop from './web_desktop.png'
import WebMobile from './web_mobile.jpg'

export default css`
  .concurrent-stream-notice {
    text-align: center;
    color: white;
    z-index: 2;
    padding: 15px;
  }
  :global(.content){
    padding: 0px !important;
  }
  .modal {
    height: 570px;
    background: url(${WebDeskop});
    padding: 42px 20px 20px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 100%;
    position: relative;
  }
 
  li{
    font-family: Source Sans Pro;
    font-size: 15.45px;
    font-weight: 400;
    line-height: 19.42px;
    text-align: left;
  }

  .wrap{
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 16px;
    align-items: center;
    padding-bottom: 24px;
  }
  h2 {
    font-family: Source Sans Pro;
    font-size: 27px;
    font-weight: 600;
    line-height: 40.8px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;    

  }
  p {
    font-family: Source Sans Pro;
    font-size: 20px;
    font-weight: 400;
    line-height: 24.4px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    padding-bottom: 37px;
    margin: 0px auto;
  }
  .device-image-outer {
    margin-bottom: 15px;
  }
  .wrap :global(.Image){
    width: 64px !important;
    height: 43px !important; 
    padding-bottom: 0px !important;
  }
  .title {
    font-family: Source Sans Pro;
    font-size: 32px;
    font-weight: 600;
    line-height: 38.4px;
    text-align: center; 
  }

  .paywall-title{
    background: linear-gradient(125.01deg, #FFFF00 16.66%, #FFE71E 65.69%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: #FFE71E;
  }

.highlight {
  font-family: Source Sans Pro;
  font-size: 32px;
  font-weight: 600;
  line-height: 38.4px;
  text-align: center;
  color: #fde047;
}

.features-list {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 8px;
  margin-bottom: 2rem;
  font-size: 1.125rem;
  list-style-type: none;
  padding: 0;
}

.features-list li::before {
  content: '•';
  margin-right: 0.5rem;
}

.cta-section {
  display: flex;
  margin-top: auto;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 0px;
}

ul {
  padding: 0px;
  margin: 0px auto;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

li {
  padding: 0.25em;
}

.price {
  font-family: Source Sans Pro;
  font-size: 18px;
  font-weight: 600;
  line-height: 22.63px;
  text-align: center;
  padding-bottom: 0px;
}

.logos-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.channel-logo {
  height: 50px;
  width: 50px;
  border-radius: 50px;
  overflow: hidden;
}

.disclaimer {
  font-family: Source Sans Pro;
  font-size: 12px;
  font-weight: 400;
  line-height: 15.08px;
  text-align: center;
  color: #9E9E9E; 
  padding-bottom: 0px;
}

.main-content{
  display: flex;
  flex-direction: column;
  height: 455px;
}
  :global(.concurrent-notice-bgimage) {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top:0;
    left:0;
    z-index: 0;
  }

  :global(.concurrent-notice-bgimage-overlay) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 1;
  }
  .button-wrap{
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 16px;
    margin: 16px auto;
  }
  .upgrade-button {
    width: 206px;
    height: 48px;
    padding: 11px;
    border: none;
    font-family: Source Sans Pro;
    font-size: 18px;
    font-weight: 600;
    line-height: 22.63px;
    text-align: center;
    border-radius: 8px;
    background: #FFFFFF;
    cursor: pointer;
  }
  .sign-up-button {
      width: 286px;
      height: 44px;
      padding: 10px;
      border: none;
      font-family: Source Sans Pro;
      font-size: 18px;
      font-weight: 600;
      line-height: 22.63px;
      text-align: center;
      border-radius: 8px;
      background: #FFFFFF;
      cursor: pointer;
  }
  .learn-more-button {
    width: 206px;
    height: 48px;
    padding: 11px;
    border: none;
    border-radius: 8px;
    background: #313131;
    font-family: Source Sans Pro;
    font-size: 18px;
    font-weight: 600;
    line-height: 22.63px;
    text-align: center;
    text-underline-position: from-font;
    color: white;
    text-decoration-skip-ink: none;
    cursor: pointer;
  }
  @media (max-width: 767px) {
    :global(.device-image-outer > img) {
      width: 202px;
      height: 33.01px;         
        }
      .wrap :global(.Image){
        width: 36px !important;
        height: 25px !important; 
        padding-bottom: 0px !important;
      }
        .device-image-outer.modal-mode {
          padding-top: 66px;
          margin-bottom: 34px;
        }
        .main-content {
          height: 100%;
          text-align: center;
        }
        
        .cta-section{
          margin-top: 75%;
        }

        .modal{
        height: 100% !important;
        top: -1px;
        background: url(${WebMobile});
        padding-bottom: 100px;
        border-radius: 0px;
        background-repeat: no-repeat;
        background-size: cover;
        border: none;
        }
        :global(.content){
          height: 100%;
        }
        .features-list{
          margin: 0 auto;
          gap: 20px;
          flex-direction: column;
        }

        .wrap{
          padding-bottom: 16px;
        }
        .sign-up-button {
          width: 280px;
          height: 37px;
      }
  }
`
